import { CollapsibleCard } from '../ui';
import {
    formatEquipmentEditHistoryValue,
    getEquipmentEditHistoryFieldLabel,
    parseEquipmentEditHistory,
} from './equipmentEditHistory';

export const EquipmentEditHistorySection = ({
    editHistoryJson,
}: {
    editHistoryJson?: string | null;
}) => {
    const history = parseEquipmentEditHistory(editHistoryJson);
    const sorted = [...history].reverse();
    const entryCount = sorted.length;

    return (
        <CollapsibleCard
            variant="light"
            title="Edit History"
            meta={entryCount > 0 ? `${entryCount} change${entryCount === 1 ? '' : 's'}` : 'None yet'}
            defaultExpanded={false}
            className="equipment-edit-history-card"
        >
            {entryCount === 0 ? (
                <p className="equipment-edit-history-empty">
                    No overview edits recorded yet. Changes saved from Edit mode will appear here.
                </p>
            ) : (
                <div className="equipment-edit-history-list">
                    {sorted.map((entry, idx) => (
                        <div key={`${entry.editedAt}-${idx}`} className="equipment-edit-history-entry">
                            <div className="equipment-edit-history-header">
                                <span className="equipment-edit-history-user">
                                    {entry.editedBy || 'Unknown'}
                                </span>
                                <span className="equipment-edit-history-date">
                                    {new Date(entry.editedAt).toLocaleDateString()}{' '}
                                    {new Date(entry.editedAt).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })}
                                </span>
                            </div>
                            <div className="equipment-edit-history-changes">
                                {Object.entries(entry.changes).map(([field, change]) => (
                                    <div key={field} className="equipment-edit-history-change">
                                        <span className="equipment-edit-history-field">
                                            {getEquipmentEditHistoryFieldLabel(field)}:
                                        </span>
                                        <span className="equipment-edit-history-from">
                                            {formatEquipmentEditHistoryValue(change.from)}
                                        </span>
                                        <span className="equipment-edit-history-arrow" aria-hidden="true">
                                            →
                                        </span>
                                        <span className="equipment-edit-history-to">
                                            {formatEquipmentEditHistoryValue(change.to)}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </CollapsibleCard>
    );
};
